import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import CartIndicator from "./IndicatorCart";
import Departments from "./Departments";
import Indicator from "./Indicator";
import IndicatorAccount from "./IndicatorAccount";
import IndicatorSearch from "./IndicatorSearch";
import { Heart20Svg, LogoSmallSvg, Power20Svg } from "../../svg";
import NavLinks from './NavLinks';
import DropdownLanguage from './DropdownLanguage';

function NavPanel(props) {
    const { layout, wishlist, user } = props;

    let logo = null;
    let departments = null;
    let searchIndicator;

    if (layout === "compact") {
        logo = (
            <div className="nav-panel__logo">
                <Link to="/">
                    <LogoSmallSvg />
                </Link>
            </div>
        );

        searchIndicator = <IndicatorSearch />;
    }

    if (layout === "default") {
        departments = (
            <div className="nav-panel__departments">
                <Departments />
            </div>
        );
    }

    return (
        <div className="nav-panel">
            <div className="nav-panel__container container">
                <div className="nav-panel__row">
                    {logo}
                    {departments}

                    
                    <div className="nav-panel__nav-links nav-links">
                        <NavLinks />
                    </div>

                    <div className="nav-panel__indicators">
                        {searchIndicator}

                        {user?.user?.isAdmin && (
                            <Indicator
                                url="/shop/AddProduct"
                                icon={<Heart20Svg />}
                            />
                        )}
                        {user?.user?.isAdmin === true && <Indicator url="/shop/order" icon={<Power20Svg />} />}
                        <CartIndicator />

                        <IndicatorAccount />

                        <DropdownLanguage />
                    </div>
                </div>
            </div>
        </div>
    );
}

NavPanel.propTypes = {
    layout: PropTypes.oneOf(["default", "compact"]),
    wishlist: PropTypes.object.isRequired,
    user: PropTypes.object,
};

NavPanel.defaultProps = {
    layout: "default",
};

const mapStateToProps = (state) => ({
    wishlist: state.wishlist,
    user: state.user.userConnected, // Assuming user state is stored in state.user
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(NavPanel);
